import React from "react";

function Work({ company, business, achievement, award, position, location, type, duration }) {
   return (
      <article className="pt-8 border-b-2 border-dark-content pb-5 dark:border-light-content border-opacity-20 dark:border-opacity-20">
         <div className="flex justify-between items-center">
            <h1 className="text-content md:text-lg lg:text-xl">{company}</h1>
            {/* <div className="btn bg-greenbg text-xs inline-block rounded-3xl px-3 py-1 min-w-fit">{type}</div> */}
         </div>
         <div className="flex justify-between pt-2">
            <div className="flex flex-col md:flex-row">
               <div className="flex items-center pr-5">
                  <svg
                     className="dark:fill-light-heading fill-dark-heading min-w-fit"
                     width="16"
                     height="12"
                     viewBox="0 0 16 12"
                     fill="none"
                     xmlns="http://www.w3.org/2000/svg"
                  >
                     <path d="M3.33331 1.5V10.5H7.33331V8.75H8.66665V10.5H12.6666V1.5H3.33331ZM4.66665 2.5H5.99998V3.5H4.66665V2.5ZM7.33331 2.5H8.66665V3.5H7.33331V2.5ZM9.99998 2.5H11.3333V3.5H9.99998V2.5ZM4.66665 4.5H5.99998V5.5H4.66665V4.5ZM7.33331 4.5H8.66665V5.5H7.33331V4.5ZM9.99998 4.5H11.3333V5.5H9.99998V4.5ZM4.66665 6.5H5.99998V7.5H4.66665V6.5ZM7.33331 6.5H8.66665V7.5H7.33331V6.5ZM9.99998 6.5H11.3333V7.5H9.99998V6.5ZM4.66665 8.5H5.99998V9.5H4.66665V8.5ZM9.99998 8.5H11.3333V9.5H9.99998V8.5Z" />
                  </svg>
                  <p className="text-content text-xs md:text-sm font-light pl-1"> {business}</p>
               </div>
            </div>
            <p className="text-content text-xs md:text-sm font-light pl-1 min-w-fit">{duration}</p>
         </div>
         <div className="flex justify-between pt-2">
            {achievement && (
               <div className="flex items-center">
                  <svg
                     className="dark:fill-light-heading fill-dark-heading min-w-fit"
                     width="16"
                     height="12"
                     viewBox="0 0 16 12"
                     fill="currentColor"
                     xmlns="http://www.w3.org/2000/svg"
                  >
                     <path d="M7.93189 1.24806C7.84228 1.09446 7.67783 1 7.5 1C7.32217 1 7.15772 1.09446 7.06811 1.24806L0.0681106 13.2481C-0.0220988 13.4027 -0.0227402 13.5938 0.0664289 13.749C0.155598 13.9043 0.320967 14 0.5 14H14.5C14.679 14 14.8444 13.9043 14.9336 13.749C15.0227 13.5938 15.0221 13.4027 14.9319 13.2481L7.93189 1.24806Z" />
                  </svg>
                  <p
                     className="text-content text-xs md:text-sm font-light pl-1"
                     dangerouslySetInnerHTML={{ __html: achievement }}
                  ></p>
               </div>
            )}
            {award && (
               <div className="flex items-center">
                  <svg
                     className="dark:fill-light-heading fill-dark-heading min-w-fit"
                     width="16"
                     height="12"
                     viewBox="0 0 16 12"
                     fill="currentColor"
                     xmlns="http://www.w3.org/2000/svg"
                  >
                     <path d="M8 1L9.8 4.6L14 5.2L11 8.2L11.8 12.4L8 10.4L4.2 12.4L5 8.2L2 5.2L6.2 4.6L8 1Z" />
                  </svg>
                  <p className="text-content text-xs md:text-sm font-light pl-1">{award}</p>
               </div>
            )}
         </div>
      </article>
   );
}

export default Work;
